import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Card, CardContent, CardHeader } from '@mui/material';
import { SettingContainer } from './container';
const titleTypographyProps = { variant: 'h6', fontWeight: 400 };
const card_sx = {
    gridColumn: '1/-1',
    '& .MuiCardContent-root': {
        pt: 0,
    },
    width: '100%',
    marginTop: 1,
    borderRadius: '9px',
    marginBottom: 1,
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'primary.dark',
    boxShadow: '0px 1px 4px 1px rgba(0, 0, 0, 0.1)',
    // '1px 2px 5px -1px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
};
export const SettingCard = memo(function SettingCard(props) {
    const { title, children, container_props, header_props } = props;
    return (_jsx(ErrorBoundary, { children: _jsxs(Card, { sx: card_sx, children: [_jsx(CardHeader, { title: title, titleTypographyProps: titleTypographyProps, ...header_props }), _jsx(CardContent, { children: _jsx(SettingContainer, { ...container_props, children: children }) })] }) }));
});
